// extracted by mini-css-extract-plugin
export default {"inputNormal":"index-module--input-normal--c235d","inputWithError":"index-module--input-with-error--87a3f"};